import ajax from '../utils/ajax'

export default {
    list: hideReviewed => ajax.get('/api/vesselMmsi/list', {params: {hideReviewed: hideReviewed ? "1" : ""}}),
    confirm: id => ajax.post('/api/vesselMmsi/confirm', {id}),
    listUnbind: () => ajax.get('/api/vesselMmsi/listUnbind'),
};
